/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto';
import type { Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DisbursementSharedService {

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementContainerStatus(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-container-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementStatus(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementDetail(
transactionId: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-detail/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @param companyId 
     * @returns Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementDetailForBrokerTradeTool(
transactionId: string,
companyId?: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-detail-for-broker-trade-tool/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            query: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementItemStatus(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-item-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
